import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.custom-box-shadow {
background: ${dt('content.background')};
box-shadow: ${dt('customBoxShadow.shadow')};
}
`;
